import {
  fetchDeliveryAddressAllowed as fetchInner,
  type DeliveryAddressValidationRequest,
} from "@the-drop/customer-shared/api/compliance";

import { getCustomerApiBaseUrl } from "./api-base";

export function fetchDeliveryAddressAllowed(req: DeliveryAddressValidationRequest) {
  return fetchInner(getCustomerApiBaseUrl(), req);
}

export type {
  DeliveryAddressValidationRequest,
  DeliveryAddressValidationResult,
} from "@the-drop/customer-shared/api/compliance";
